import { cn } from "@/lib/utils";
import React from "react";

type CTABannerProps = {
  title: string;
  subtitle: string;
  bgColour: string;
};

const CTABanner: React.FC<CTABannerProps> = ({ title, subtitle, bgColour }) => {
  return (
    <div
      className={cn(
        "mt-8 flex w-full select-none items-center justify-center rounded-xl",
        `bg-${bgColour}`,
      )}
      style={{ height: "30rem" }}
    >
      <div className="text-center">
        <h2
          className="mb-8 font-regular text-3xl text-white"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h2>
        <p
          className="font-light text-white"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        ></p>
      </div>
    </div>
  );
};

export default CTABanner;
